import { Box, Button, FormControl, FormLabel, Input, Select, Text, useTheme, InputGroup, InputLeftAddon } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../../App';
import { getAllByTableName, sendFormData } from '../../../utils/dataFetch';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import CustomAlertWeb from '../../../components/customAlertWeb/customAlertWeb';

export default function InscriptionFormCustom({ customStyles = {}, IdTipoContacto }) {
  const { IdCurso } = useParams();
  const [formData, setFormData] = useState({  
  NumeroSinPrefijo: '',
  PaisLead: 'Argentina', // valor por defecto
});
  const [countries, setCountries] = useState([]);
  const [newIdLead, setNewIdLead] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [sendingData, setSendingData] = useState(null);
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile, customStyles);
  const inputArray = ['Nombre', 'Email', 'País', 'Telefono', 'Comentario'];
  const [paisError, setPaisError] = useState(false);

  const handleSubmit = (evt) => {
    if (!formData.PaisLead) {
  setPaisError(true);
  setSendingData(false);
  return;
}
setPaisError(false); // Limpia el error si ya lo había marcado
    setSendingData(true);
    evt.preventDefault();

    formData.Comentario = formData.ComentarioLead;
    delete formData.ComentarioLead;

    const gclidRecord = JSON.parse(localStorage.getItem("gclid"));
    const gclid = gclidRecord && new Date().getTime() < gclidRecord.expiryDate
      ? gclidRecord.value
      : null;

    console.log("✅ GCLID enviado:", gclid);

    // Backup para CRM antes de borrar campos como PaisLead
    const formDataForCRM = {
      NombreLead: formData.NombreLead,
      EmailLead: formData.EmailLead,
      TelefonoLead: formData.TelefonoLead,
      Comentario: formData.Comentario,
      IdCurso: IdCurso,
      PaisLead: formData.PaisLead,
      Gclid: gclid
    };

    delete formData.PaisLead;

    console.log('Form data', {
      ...formData,
      IdCurso,
      Fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
      IdTipoContacto,
      IdLead: newIdLead
    });

    // Envío a CRM
    fetch('/api/enviar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formDataForCRM)
    })
      .then(res => res.text())
      .then(data => {
        console.log("📨 Enviado al CRM. Respuesta:", data);
      })
      .catch(err => {
        console.error("❌ Error al enviar al CRM:", err);
      });

    // Envío normal del sistema
    // Eliminar campo auxiliar que no existe en la base de datos
const { NumeroSinPrefijo, ...cleanFormData } = formData;

// Envío normal del sistema
sendFormData({
  ...cleanFormData,
  IdCurso,
  Fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
  IdTipoContacto,
  IdLead: newIdLead,
  Gclid: gclid
})
      .then(res => {
        // 🔁 Medición de conversión Google Ads
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-984573655/P1feCI6Bos8aENfNvdUD',
            event_callback: () => {
              console.log('Conversión registrada');
              // window.location.href = "/gracias";
            }
          });
        }

        setShowAlert({
          status: 'success',
          message: 'Los datos han sido enviados con éxito!'
        });
      })
      .catch(error => setShowAlert({
        status: 'error',
        message: error?.message || 'Ha ocurrido un error al enviar los datos'
      }))
      .finally(() => setSendingData(false));
  };

  useEffect(() => {

  getAllByTableName('pais').then(res => {
    setCountries(res);

    // ✅ Si ya está Argentina como default, prellenar el prefijo
    const defaultCountry = res.find(c => c.NombrePais === 'Argentina');
    if (defaultCountry) {
      setFormData(prev => ({
        ...prev,
        TelefonoLead: defaultCountry.Prefijo + (prev.NumeroSinPrefijo || '')
      }));
    }
  });

  getAllByTableName('leads').then(res => {
    setNewIdLead(Math.max(...res.map(item => parseInt(item.IdLead, 10))) + 1);
  });
}, []);

  const getPrefix = (value) => {
  const selectedCountry = countries.find(c => c.NombrePais === value);
  const prefijo = selectedCountry?.Prefijo || '';
  setFormData(prev => ({
    ...prev,
    PaisLead: value,
    TelefonoLead: prefijo + (prev.NumeroSinPrefijo || '')
  }));
};


  return (
    <Box style={style.container} id={"inscription-form-id"} className="quicksand-semibold" >
      <Text style={style.title}>Formulario de Contacto</Text>
      <form onSubmit={handleSubmit} style={style.form}>
        {inputArray.map((input, i) => (
  <div key={`${input}-${i}`}>
    {input === "Telefono" ? (
      <FormControl mb="4" height={"10%"} isRequired>
        {paisError && (
  <Text fontSize="sm" color="red.500" pl="1rem" pt="0.5rem">
    Debes seleccionar un país para completar el teléfono
  </Text>
)}
        <FormLabel
          sx={{ fontSize: '1.5rem', color: 'grey', paddingLeft: '1rem', fontWeight: "normal" }}
        >
          Teléfono
        </FormLabel>
        <InputGroup>
  <InputLeftAddon
    children={countries.find(c => c.NombrePais === formData.PaisLead)?.Prefijo || '+--'}
    bg="gray.100"
    color="gray.700"
    fontWeight="bold"
    fontSize="1.2rem"
    border="1px solid #CBD5E0"
    borderRadius="md"
    px="1rem"
    height="3rem"
    display="flex"
    alignItems="center"
    justifyContent="center"
  />
  <Input
    id="telefono-input"
    placeholder="Número sin prefijo"
    value={formData.NumeroSinPrefijo || ''}
    isRequired
    pattern="\d*"
    fontSize="1.2rem"
    height="3rem"
    borderRadius="md"
    border="1px solid #CBD5E0"
    borderLeft="none"
    onChange={(e) => {
      const numero = e.target.value.replace(/\D/g, '');
      const prefijo = countries.find(c => c.NombrePais === formData.PaisLead)?.Prefijo || '';
      setFormData(prev => ({
        ...prev,
        NumeroSinPrefijo: numero,
        TelefonoLead: prefijo + numero
      }));
    }}
  />
</InputGroup>


      </FormControl>
    ) : input === "País" ? (
      <FormControl mb={4} isRequired>
        <FormLabel
          sx={{ fontSize: '1.5rem', color: 'grey', paddingLeft: '1rem', fontWeight: "normal" }}
        >
          País
        </FormLabel>
        <Select
          name="Pais"
          value={formData.PaisLead || ''}
          onChange={(e) => {
            setFormData({
              ...formData,
              [`${e.target.name}Lead`]: e.target.value,
            });
            getPrefix(e.target.value);
          }}
        >
          <option value="">Selecciona un país</option>
          {countries?.map((country, i) => (
            <option key={`${country}-${i}`} value={country?.NombrePais}>
              {country?.NombrePais}
            </option>
          ))}
        </Select>
      </FormControl>
    ) : (
      <FormControl mb="4" height={"10%"}>
        <Input
          id={`input-${input}`}
          value={formData[`${input}Lead`] || ''}
          placeholder={input}
          isRequired={true}
          style={style.input}
          onChange={(evt) =>
            setFormData({ ...formData, [`${input}Lead`]: evt.target.value })
          }
        />
      </FormControl>
    )}
  </div>
))}
        {/* <CaptchaCustom /> */}
        <Button
          type="submit"
          colorScheme="teal"
          width="100%"
          alignSelf="center"
          fontSize={isMobile ? "1rem" : "2rem"}
          p="2rem"
          disabled={sendingData}
          {...customStyles.button}
        >
          Solicitar Información
        </Button>
        {showAlert && <CustomAlertWeb {...showAlert} onClose={() => setShowAlert(null)} />}
      </form>
    </Box>
  );
}


const styles = (theme, isMobile, customStyles) => ({
  container: {
    width: isMobile ? '100%' : '40%',
    display: 'flex',
    flexDirection: 'column',
    padding: '4%',
    marginTop: isMobile ? '2rem' : 0,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.6)",
    ...customStyles.container
  },
  title: {
    textAlign: 'center',
    fontSize: isMobile ? '1.5rem' : '2rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-evenly'
  },
  input: {
    fontSize: '1.5rem',
    marginTop: '2vh',
    borderColor: 'transparent',
    borderRadius: 0,
    borderBottomColor: theme.background.tertiary,
  }
});